import React from 'react'
import {friendElement,Breadcrumb} from './myFunctions.js';
export default function FriendButtonListEntry({friend,oym,dropBreadcrumb,authenticated}) {
    console.log("authenticated:",authenticated);
    var friendObject= oym.objectRef(friend);
    function dropFriendBreadcrumb(e){
        dropBreadcrumb(new Breadcrumb(friendObject.lastName,friendElement(oym,friendObject,dropBreadcrumb)));
    }
    if (authenticated!==undefined&&authenticated){
        return (
            <>
            <button onClick={dropFriendBreadcrumb}>{friendObject.name }</button> &nbsp;
            </>
        )
    } else {
        return (
            <>
            {friendObject.name }
            </>
        )
    }
}
